import {combineReducers} from "redux";
import prismic from "./prismic";
import cookieCompliance from "./cookie_compliance";
import loading from "./loading";
import accessibility from "./accessibility";
import dialog from "./dialog";

const rootReducer = combineReducers({
  prismic,
  cookieCompliance,
  loading,
  accessibility,
  dialog,
});

export default rootReducer;
